import { render, staticRenderFns } from "./old-card-info.vue?vue&type=template&id=72a45f32&scoped=true&lang=pug&"
import script from "./old-card-info.vue?vue&type=script&lang=js&"
export * from "./old-card-info.vue?vue&type=script&lang=js&"
import style0 from "./old-card-info.vue?vue&type=style&index=0&id=72a45f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a45f32",
  null
  
)

export default component.exports